<template>
  <div v-if="caseList" class="category-doc">
    <div class="group__title flex items-center">
      <h2 class="title flex-1">
        {{ category.title }}
      </h2>
      <nuxt-link
        type="text"
        class="more-btn flex justify-center items-center cursor-pointer"
        aria-label="go academy detail"
        :to="{ name: PageKey.CASE }"
      >
        {{ $t('cha-kan-geng-duo') }}
        <iconpark-icon name="arrowright" size="16"></iconpark-icon>
      </nuxt-link>
    </div>
    <div class="group__content">
      <BaseCard
        v-for="card in caseList.slice(0, 4)"
        :key="card.id"
        :data="formatCard(card)"
        @go="handleCardClick(card)"
      >
        <template #title>
          <template v-if="cardName(card.title).length > 1">
            <span class="main-title font-[600]">
              {{ cardName(card.title)[0] }}
            </span>
            <span class="sub-title"> | {{ cardName(card.title)[1] }} </span>
          </template>
          <template v-else>
            {{ card.title }}
          </template>
        </template>
      </BaseCard>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { getCaseList } from '~/api';
import type { IGetCaseItem } from '~/api/interface/publicize';
import type { IHelpCategory } from '~/api/module/help-center';
import BaseCard, { type IBaseCardData } from '~/components/content/baseCard.vue';
import { PageKey } from '~/constants/page';

defineProps<{
  category: IHelpCategory;
}>();

const { data: caseList } = useAsyncData(async () => {
  const res = await getCaseList({
    page: 1,
    page_size: 4,
  });
  return res.data?.results || [];
});

const cardName = (name: string) => name.split('丨'); // @xi18n-ignore

const formatCard = (card: IGetCaseItem) => {
  return {
    title: card.title,
    cover_image_url: card.cover_image_url,
    is_new: card.is_new,
    path_url: card.path_url,
  } as IBaseCardData;
};

const handleCardClick = (card: IGetCaseItem) => {
  navigateTo({ name: PageKey.CASE_DETAIL, params: { post: card.path_url } });
};
</script>

<style lang="scss" scoped>
.group {
  &__title {
    h2 {
      font-size: 18px;
      line-height: 1.4;
      color: var(--text-1);
    }
    .more-btn {
      font-size: 14px;
      line-height: 1;
      color: var(--text-1);
      opacity: 0.6;
      &:hover {
        opacity: 0.9;
      }
    }
  }
  &__content {
    display: grid;
    grid-template-columns: repeat(4, minmax(56px, 1fr));
  }
}
</style>
